import React from 'react';

import { UnitTrackingProps } from './UnitTracking.props';

import UnitTrackingView from './UnitTracking.view';

const UnitTrackingContainer = (props: UnitTrackingProps) => {
  return <UnitTrackingView />;
};

export default UnitTrackingContainer;
